<template>
<div class="row">
	<div class="col-md-3">
		<div class="card mb-3">
			<div class="card-body">
				<h5 class="card-title">{{ producto.categoria_uno }}</h5>
				<h6 class="card-subtitle mb-2 text-muted">
					Q {{ producto.presentacion_seleccionada == '' ? producto.precio : producto.presentacion_seleccionada.precio }}
				</h6>
				<p class="card-text">{{ producto.descripcion }}</p>
			</div>
			<div class="card-footer">
				<BazarForm :producto="producto" :emp="emp" @actTotal="$emit('actTotal')"/>
			</div>
		</div>
	</div>
	<div class="col-md-9">
		<div id="c807ProductoLista" class="carousel slide mb-3" data-ride="carousel">
			<ol class="carousel-indicators">
				<li v-for="(i,idx) in producto.imagenes"
                  :key="i.id"
                  data-target="#carouselExampleIndicators"
                  :data-slide-to="idx"
                  :class="idx == 0 ? 'active':''"
                ></li>
			</ol>
			<div class="carousel-inner">
				<template v-for="(i, idx) in producto.imagenes">
					<div 
						class="carousel-item" 
						v-if="i.drive_id !== null || i.ubicacion !== null || i.ubicacion !== 'TEMP'"
						:class="idx == 0 ? 'active':''"
						:key="i.id"
					>
						<img 
							v-if="i.drive_id !== null"
							:src="UrlImgDrive+i.drive_id" 
							class="d-block mx-auto" 
							:alt="producto.nombre" 
							style="max-width: 100%;"
						>
						<img 
							:src="'/'+i.ubicacion" 
							class="d-block mx-auto" 
							:alt="producto.nombre" 
							style="max-width: 100%;"
							v-else
						>
					</div>
				</template>
			</div>
			<a class="carousel-control-prev" href="#c807ProductoLista" role="button" data-slide="prev">
				<span class="carousel-control-prev-icon" aria-hidden="true"></span>
				<span class="sr-only">Previous</span>
			</a>
			<a class="carousel-control-next" href="#c807ProductoLista" role="button" data-slide="next">
				<span class="carousel-control-next-icon" aria-hidden="true"></span>
				<span class="sr-only">Next</span>
			</a>
		</div>
	</div>
</div>
</template>

<script>
import BazarForm from './BazarForm.vue';

export default {
	name: 'BazarModal',
	props: {
		producto: {
			type: Object,
			required: true
		},
		emp: {
            type: Object,
            required: true
        }
	},
	components: {
		BazarForm
	}
}

</script>
